import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/swishr-pulse-v-119f21a/src/providers/index.tsx");
